import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ExpandButtonContainer = styled.div`
  margin: 0 auto;
  border: solid ${pxToRem('1px')} ${props => props.theme.colors.lightGray2};
  border-radius: ${pxToRem('27px')};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  align-items: center;
  width: auto;
  max-width: ${pxToRem('48px')};
  height: ${pxToRem('48px')};
  color: ${props => props.theme.colors.aquamarine};
  text-transform: uppercase;
  overflow: hidden;
  padding: 0 ${pxToRem('15px')};
  transition: max-width 0.5s;
  -webkit-transition: max-width 0.5s;
  cursor: pointer;

  > span {
    white-space: pre;
    cursor: pointer;
  }

  :hover {
    max-width: ${pxToRem('200px')};
  }
`;

export const IconContainer = styled.div`
  > div {
    font-weight: bold;
    margin-right: ${pxToRem('27px')};
    color: inherit;
  }
`;
